import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, Button } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import moment from 'moment';
import DualActionDialog from '../DualActionDialog';
import { hazardStatus } from '../../constants';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  date: {
    paddingTop: theme.spacing(1),
    display: 'inline',
    paddingLeft: theme.spacing(3)
  },
  dateExpired: {
    paddingTop: theme.spacing(1),
    display: 'inline',
    paddingLeft: theme.spacing(3),
    color: theme.palette.danger.main,
    fontWeight: 800
  },
  deactivateContainer: {
    paddingTop: theme.spacing(2)
  },
  editDeleteContainer: {
    // paddingTop: theme.spacing(1)
  },
  editButton: {
    color: theme.palette.secondary.main
  },
  deleteButton: {
    color: theme.palette.danger.main
  },
  companyDetails: {
    display: 'inline'
  },
  hazardDescription: {
    fontSize: 18,
    fontWeight: 'normal',
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(3),
    display: 'inline'
  },
  hazardStatus: {
    display: 'inline',
    paddingRight: theme.spacing(10)
  }
}));

const SingleHazard = (props) => {
  const {
    hazard,
    documents,
    handleHazardEditClick,
    handleHazardControlEditClick,
    handleHazardReviewClick,
    handleHazardManagementLogsClick,
    openDeleteHazardDialog,
    loggedInUser
  } = props;
  const classes = useStyles();
  const isExpired = moment().isAfter(hazard.nextReviewDate);

  const getHazardStatus = (statusId) => {
    const value = hazardStatus.hazardStatus.find((item) => item.id === statusId)
      .value;
    return value;
  };

  return (
    <React.Fragment>
      <Paper>
        <div className={classes.container}>
          <Grid container>
            <Grid item xs={7}>
              <div className={classes.companyDetails}>
                <Typography variant="h3" className={classes.hazardDescription}>
                  {hazard && hazard.description}
                </Typography>
              </div>
            </Grid>
            <Grid item xs="auto">
              Status:&nbsp;
              <Typography variant="subtitle2" className={classes.hazardStatus}>
                {hazard && getHazardStatus(hazard.status)}
              </Typography>
              <Typography
                variant="subtitle2"
                className={isExpired ? classes.dateExpired : classes.date}
              >
                {hazard &&
                  hazard.nextReviewDate &&
                  `Next Review - ${moment(hazard.nextReviewDate).format(
                    'DD/MM/YYYY'
                  )}`}
              </Typography>
            </Grid>
            <Grid item xs="auto">
              <div className={classes.editDeleteContainer}>
                <Button
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() =>
                    handleHazardEditClick({ ...hazard }, loggedInUser.id)
                  }
                >
                  Hazard Detail
                </Button>
                <Button
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() => handleHazardControlEditClick({ ...hazard })}
                >
                  Controls
                </Button>
                <Button
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() => handleHazardReviewClick({ ...hazard })}
                >
                  Reviews
                </Button>
                <Button
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() => handleHazardManagementLogsClick({ ...hazard })}
                >
                  Management Logs
                </Button>
                <Button
                  startIcon={<DeleteOutlineIcon />}
                  className={classes.deleteButton}
                  onClick={() => openDeleteHazardDialog(true, { ...hazard })}
                >
                  Delete
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </React.Fragment>
  );
};

const HazardsList = (props) => {
  const {
    branchId,
    hazards,
    documents,
    fetchAllHazardsForBranch,
    fetchAllDocuments,
    handleHazardEditClick,
    handleHazardControlEditClick,
    handleHazardReviewClick,
    handleHazardManagementLogsClick,
    openDeleteDialog,
    openDeleteHazardDialog,
    hazardToBeDeleted,
    isDeletingHazard,
    errorMessage,
    submitDeleteHazardRequest,
    selectedSortFilter,
    loggedInUser
  } = props;

  React.useEffect(
    () => {
      if (branchId) {
        fetchAllHazardsForBranch(branchId);
      }
      if (loggedInUser.role === 1) {
        fetchAllDocuments(branchId);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [branchId]
  );

  const handleConfirmDelete = (e) => {
    submitDeleteHazardRequest(hazardToBeDeleted);
  };

  return (
    <React.Fragment>
      {openDeleteDialog === true ? (
        <DualActionDialog
          open={openDeleteDialog}
          title={`Delete ${hazardToBeDeleted.description}`}
          description={`This hazard will be deleted. Are you sure you want to delete ${hazardToBeDeleted.description}?`}
          actionButtonText="Delete"
          cancelButtonText="Cancel"
          handleClose={() => openDeleteHazardDialog(false, hazardToBeDeleted)}
          handleSubmit={handleConfirmDelete}
          showProgressBar={isDeletingHazard || false}
          errorMessage={errorMessage || ''}
          isDanger={true}
        />
      ) : null}
      {hazards &&
        hazards.map((hazard) => {
          return (
            <SingleHazard
              hazard={hazard}
              key={hazard.id}
              documents={documents}
              handleHazardEditClick={handleHazardEditClick}
              handleHazardControlEditClick={handleHazardControlEditClick}
              handleHazardReviewClick={handleHazardReviewClick}
              handleHazardManagementLogsClick={handleHazardManagementLogsClick}
              openDeleteHazardDialog={openDeleteHazardDialog}
              loggedInUser={loggedInUser}
            />
          );
        })}
    </React.Fragment>
  );
};

export default HazardsList;
